import { Collapse } from 'antd5';
import styled from 'styled-components';

export const CollapseV5 = styled(Collapse)`
  background: ${({ theme }) => theme.secondaryBackgroundColor} !important;
  border: 1px solid ${({ theme }) => theme.borderColor};
  border-radius: unset;

  .ant-collapse-item:not([class*='PropagationPanel']) {
    border: none;
  }

  .ant-collapse-item:last-of-type:not(.ant-collapse-item-active) {
    .ant-collapse-header {
      border-bottom: unset;
    }
  }

  .ant-collapse-header {
    background: ${({ theme }) => theme.tertiaryBackgroundColor} !important;
    border-bottom: 1px solid ${({ theme }) => theme.borderColor};
    border-radius: unset !important;
    color: ${({ theme }) => theme.headerColor} !important;
  }
  .ant-collapse-content {
    background: ${({ theme }) => theme.secondaryBackgroundColor} !important;
    border: none !important;
    border-radius: unset !important;

    color: ${({ theme }) => theme.textColor};
  }
`;
